import { render } from "./app.vue?vue&type=template&id=657899c0"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=657899c0&lang=css"

import exportComponent from "/builds/macys/polaris/app/bag-and-checkout/bag-and-checkout-app/._tmpdirxxx/.node/lib/node_modules/@core/vue-cli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__